import configUrl from '../../config/configUrl';
class Config {

    url = configUrl.ordinaryUrl; //问卷模块访问后端地址
    addSympathy = "/sympathy/addSympathy";//添加慰问
    selectSympathy = "/sympathy/selectSympathy"; //获取慰问列表
    getArrovalInfo = "/ApprovalContent/getArrovalInfo"; //获取慰问制度
    wxOLActivityDetails = "/activityol/wxOLActivityDetails"; //线上活动查询
    submitFilesForActivity = "/activityol/submitFilesForActivity"; //线上活动提交
    updateSubmitedFilesForActivity = "/activityol/updateSubmitedFilesForActivity"; //线上活动更新
    uploadFile = "/activityol/uploadFile";//上传图片
    getSubmitFilesOfActivity = "/activityol/getSubmitFilesOfActivity";//获取已提交的线上活动数据
    integralAll = "/point/getStaffPoint"; //获取个人总积分
    stepAll = "/step/staffCurrentStep"; //获取个人总步数
    integralDetail = "/point/getStaffPointRecord"; //积分明细
    integralSystem = "/rule/getRuleByType"; //积分制度
    sevenStep = "/step/staffRecentDayRecord"; //积分制度
    staffRankByType = "/step/staffRankByTimeType"; //日周月总步数
    getStaffStepStatistic = "/step/getStaffStepStatistic"; //日周月步数柱状统计
    getSignature = "/weChat/getSignature"; //获取步数授权
    getDictValue = "/dictValueController/getDictValue"; //获取数据字典根据字典类型
    getFieldValue = "/dictValueController/getFieldValue"; //获取动态属性字典
    getListDate = "/hospitalStaffAttr/findAll";//获取人员属性list
    // 首页
    getUserMenuAPP = "/userLoginController/getUserMenuAPP";//首页的功能专区
    getNewsCarouselAPP = "/welfareController/getNewsCarouselAPP";//首页轮播图
    getNewsType = "/welfareController/getNewsType";//资讯分类列表
    getNewsTypeAPP = "/welfareController/getNewsTypeAPP";//资讯分类列表app
    getNewsList = "/welfareController/getNewsList";//资讯分类列表详情数据
    getNewsListAPP = "/welfareController/getNewsListAPP";//资讯分类列表详情数据app
    getStaffDetails = "/hospitalStaffController/getStaffDetails";//获取人员属性详细信息
    getUserDictValue = "/userDefinedController/getUserDictValue";//获取慰问 属性数据
    getUserIdMenuAPP = "/userLoginController/getUserIdMenuAPP";//获取用户菜单
    getAllMenuAPP = "/userLoginController/getAllMenuAPP";//获取全部菜单
    saveUserIdMenuAPP = "/userLoginController/saveUserIdMenuAPP";//保存用户菜单
    /*福利*/
    //  getWelfareList = "welfareController/getWelfareList"; //获取福利列表
    getWelfareList = "/appPersonController/getAppWelfareList"; //获取福利列表
    getUserDictValueAllData = "/userDefinedController/getUserDictValueAllData";//慰问导出全部（包含删除的）
    enquiryAgent = "/RequestApprovalContent/sendRequest";//获取我的审批列表
    getOfficeTree = "/consolation/officeTree";//获取慰问数据和组织数据
    getOneData = "/sympathy/getOneCondition";//获取慰问数据
    queryHistoricActivitiInstancebyPlanid = "/RequestApprovalContent/sendRequest";// 查询流程
    // approval = "/RequestApprovalContent/sendRequest";// 审批接口
    approval = "/RequestApprovalContent/sendNewRequest";// 审批接口

    integralDetail = "/point/getStaffPointRecord"; //积分明细
    integralSystem = "/rule/getRuleByType"; //积分制度
    sevenStep = "/step/staffRecentDayRecord"; //积分制度
    updateStaffPhotoAPP = "/appPersonController/updateStaffPhotoAPP";//修改保存个人信息
    myComforts = "/sympathy/myComforts";//获取签名列表
    saveSignature = "/sympathy/saveSignature";//保存签名
    getAutograph = "/ApprovalContent/getArrovalInfoAll";//获取审批签名开关
    getAcquisitionSystem = "/ApprovalContent/getArrovalInfo";//获取苦难补助

    getCurrentQuestionAllSubject = "/testPager/getPaperQuestions"; //获取当前问卷所有的题目
    saveQuestionAnswer = "/answer/save";//答卷提交
    getQuestionScore = "/questionnair/calculateScore"; // 计算分数
    /*普惠商城*/
    getCityList = "/receiveAddress/getCityList"; //获取城市列表
    getAddressByStaff = "/receiveAddress/getAddressByStaff"; //获取用户收货地址列表
    addOrUpdateAddress = "/receiveAddress/addOrUpdateAddress"; //新增更新地址
    delAddress = "/receiveAddress/delAddress"; //删除地址
    orderList = "/orders/list"; //兑换记录
    saveOrder = "/orders/saveOrder"; //下单
    listProduct = "/product/listProduct"; //商品详情
    createOrder = "/orders/createOrder"; //确认订单
    eShopProductList = "/product/eShopProductList"; //商城首页

    // 民主
    deleteInviteProposal = "/demoratic/propral/deleteInviteProposal";//删除附议代表
    wechatRepreList = "/demoratic/repre/wechatRepreList";//获取大会列表
    wechatRepreDetail = "/demoratic/repre/wechatRepreDetail";//获取详情
    subDemoraticVoteSuggest = "/demoratic/repre/subDemoraticVoteSuggest";//提交表决
    subDemoraticVoteRecord = "/demoratic/repre/subDemoraticVoteRecord";//提交意见
    wechatProposalList = "/demoratic/propral/wechatProposalList";//查看征集列表
    wechatProposalSupportList = "/demoratic/propral/wechatProposalSupportList";//查看征集附议列表
    proposalDetail = "/demoratic/propral/proposalDetail";// 查看详情
    personnelWechatRepreList = "/demoratic/propral/wechatRepreList";//获取人员列表
    saveProposal = "/demoratic/propral/saveProposal";//保存提案
    proposalAndSignatureDetail = "/demoratic/propral/proposalAndSignatureDetail";//查询详情
    inviteSupportProposal = "/demoratic/propral/inviteSupportProposal";//提交附议人员接口
    signatureDetail = "/demoratic/propral/signatureDetail";//详情
    supportSignatrueSubmit = "/demoratic/propral/supportSignatrueSubmit";//附议代表签名接口
    submitProposal = "/demoratic/propral/submitProposal";//提交接口
    findLeaderAndDeptList = "/hospitalStaffController/findLeaderAndDeptList";//获取科室和人员信息
    getUnionAndDeptRepreTree = "/demoratic/propral/getUnionAndDeptRepreTree";//获取组织信息
    getNewsDetail = "/welfareController/getNewsDetail"; //资讯详情
    getIntegralData = "/pointReg/findReg";//获取积分参数
    setStaffPointAPP = "/welfareController/setStaffPointAPP";//资讯积分
    getActivityolSystemGallery = "/activityol/systemGallery";//获取登录页LOGO以及医院名称

    getDictionaryList = "/consolationDictionary/getDictionaryList";//查询亲属去世字典项

    getSignUpType = '/activityController/getSignUpType';//获取报名类型
    signUpByStaff = '/activityController/signUpByStaff';//按人员报名(类型)
    getStr(str) {
        return config[str];
    }
}
let config = new Config();
export default config;
